import { SearchHighlightOverlay } from 'features/knowledgeDocumentViewer/components/viewer/search/SearchHighlightOverlay'
import type { NormalizedBBox } from 'features/knowledgeDocumentViewer/types/ocrViewer'
import React, { useMemo } from 'react'
import styled from 'styled-components'

const HighlightSvg = styled.svg`
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
`

interface PreviewCitedTextOverlayProps {
  boxes: NormalizedBBox[]
  imageNatural: { w: number; h: number }
}

export function PreviewCitedTextOverlay({
  boxes,
  imageNatural,
}: PreviewCitedTextOverlayProps): React.ReactElement {
  const highlights = useMemo(
    () => ({
      matches: [{ id: 0, bboxes: boxes }],
      activeMatchId: 0,
      color: 'green' as const,
    }),
    [boxes]
  )
  return (
    <HighlightSvg
      viewBox={`0 0 ${imageNatural.w} ${imageNatural.h}`}
      aria-hidden>
      <SearchHighlightOverlay
        highlights={highlights}
        imageNatural={imageNatural}
      />
    </HighlightSvg>
  )
}
